import * as React from "react";
import { forwardRef } from "react";
const SvgPlay = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", "data-svgr-icon": "true", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { id: "play" }, /* @__PURE__ */ React.createElement("path", { id: "Icon", d: "M5 5.6184C5 4.33208 6.39536 3.53063 7.50645 4.17876L15.0193 8.56123C16.1218 9.20437 16.1218 10.7974 15.0193 11.4405L7.50645 15.823C6.39536 16.4711 5 15.6697 5 14.3833V5.6184ZM14.1795 10.0009L6.66667 5.6184V14.3833L14.1795 10.0009Z", fill: "white" })));
const ForwardRef = forwardRef(SvgPlay);
export { ForwardRef as ReactComponent };
